import React from 'react';

export class RectangularInputForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      origin: props.origin || { x: 0, y: 0, z: 0 },
      size: props.size || { width: 1, height: 1 },
      angle: props.angle || 0,
    };
  }

  notify() {
    const { name, onDataChanged, origin, size, angle } = this.props;
    if (onDataChanged) {
      const data = {};
      if (origin !== undefined) {
        data.x = parseFloat(this.state.origin.x || 0);
        data.y = parseFloat(this.state.origin.y || 0);
        data.z = parseFloat(this.state.origin.z || 0);
      }
      if (size !== undefined) {
        data.width = parseFloat(this.state.size.width || 0);
        data.height = parseFloat(this.state.size.height || 0);
      }
      if (angle !== undefined) {
        data.angle = parseFloat(this.state.angle || 0);
      }
      onDataChanged(name, data);
    }
  }

  updateOrigin(key, value) {
    const origin = { ...this.state.origin, [key]: value };
    this.setState({ origin }, () => this.notify());
  }

  updateSize(key, value) {
    const size = { ...this.state.size, [key]: value };
    this.setState({ size }, () => this.notify());
  }

  updateAngle(value) {
    this.setState({ angle: value }, () => this.notify());
  }

  renderOriginInputs() {
    const { t } = this.props;
    const { origin } = this.state;
    return (
      <div style={{ marginBottom: 16 }}>
        <h5 style={{ marginBottom: 8 }}>{t('position') || 'Position'}</h5>
        <div style={{ display: 'flex', gap: 12 }}>
          <div style={{ flex: 1 }}>
            <label>{`X (${t('meter abbrv')})`}</label>
            <input
              type="number"
              value={origin.x}
              onChange={e => this.updateOrigin('x', e.target.value)}
              onFocus={this.props.onFocus}
              onBlur={this.props.onBlur}
              style={{ width: '100%' }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label>{`Y (${t('meter abbrv')})`}</label>
            <input
              type="number"
              value={origin.y}
              onChange={e => this.updateOrigin('y', e.target.value)}
              onFocus={this.props.onFocus}
              onBlur={this.props.onBlur}
              style={{ width: '100%' }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label>{`Z (${t('meter abbrv')})`}</label>
            <input
              type="number"
              value={origin.z}
              onChange={e => this.updateOrigin('z', e.target.value)}
              onFocus={this.props.onFocus}
              onBlur={this.props.onBlur}
              style={{ width: '100%' }}
            />
          </div>
        </div>
      </div>
    );
  }

  renderSizeInputs() {
    const { t } = this.props;
    const { size } = this.state;
    return (
      <div style={{ marginBottom: 16 }}>
        <h5 style={{ marginBottom: 8 }}>{t('size') || 'Size'}</h5>
        <div style={{ display: 'flex', gap: 12 }}>
          <div style={{ flex: 1 }}>
            <label>{`${t('width')} (${t('meter abbrv')})`}</label>
            <input
              type="number"
              value={size.width}
              min={0.01}
              onChange={e => this.updateSize('width', e.target.value)}
              onFocus={this.props.onFocus}
              onBlur={this.props.onBlur}
              style={{ width: '100%' }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label>{`${t('height')} (${t('meter abbrv')})`}</label>
            <input
              type="number"
              value={size.height}
              min={0.01}
              onChange={e => this.updateSize('height', e.target.value)}
              onFocus={this.props.onFocus}
              onBlur={this.props.onBlur}
              style={{ width: '100%' }}
            />
          </div>
        </div>
      </div>
    );
  }

  renderAngleInputs() {
    const { t } = this.props;
    const { angle } = this.state;
    return (
      <div style={{ marginBottom: 16 }}>
        <h5 style={{ marginBottom: 8 }}>{t('angle') || 'Angle'}</h5>
        <div style={{ display: 'flex', gap: 12 }}>
          <div style={{ flex: 1 }}>
            <label>{`${t('angle')} (°)`}</label>
            <input
              type="number"
              value={angle}
              min={0}
              max={90}
              onChange={e => this.updateAngle(e.target.value)}
              onFocus={this.props.onFocus}
              onBlur={this.props.onBlur}
              style={{ width: '100%' }}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { origin, size, angle } = this.props;
    return (
      <div style={{ width: '100%' }}>
        {origin !== undefined && this.renderOriginInputs()}
        {size !== undefined && this.renderSizeInputs()}
        {angle !== undefined && this.renderAngleInputs()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/sc_editor/RectangularInputForm.js